import BaseApplication from 'js/core/BaseApplication';
import CameraManager from 'js/core/CameraManager';
import SceneManager from 'js/core/SceneManager';
import Debug from 'js/core/Debug';
import Screen from 'js/core/Screen';
import CameraController from 'js/components/CameraController/CameraController';
import CameraUtilities from 'js/core/utilities/CameraUtilities';
import PerspectiveCamera from 'js/core/PerspectiveCamera';
import OrthographicCamera from 'js/core/OrthographicCamera';


import Input from 'js/core/Input';

import Grid from 'js/core/components/Grid';
import Cube from 'js/core/primitives/Cube';
import Sphere from 'js/core/primitives/Sphere';
import Arrow from 'js/core/primitives/Arrow';
import ObjectAxis from 'js/core/components/ObjectAxis';

import ResourceContainer from 'js/core/ResourceContainer';
import ModelUtilities from 'js/core/utilities/ModelUtilities';
import NormalAORender from 'js/core/render_mode/NormalAORender';
import NormalRender from 'js/core/render_mode/NormalRender';
import Graphics from 'js/core/Graphics';

import Time from 'js/core/Time';
import ArrowPath from 'js/components/ArrowPath';
import CameraViewCube from 'js/components/camera_view_cube/CameraViewCube';
import LayeredRender from 'js/components/LayeredRender';
import MultiLineText2D from 'js/core/components/MultiLineText2D';
import Line from 'js/core/components/Line';
import ArrayUtilities from 'js/core/utilities/ArrayUtilities';
import Text2D from 'js/core/components/Text2D';
import MathUtilities from 'js/core/utilities/MathUtilities';
import Configuration from 'js/singletons/Configuration';

import HorizontalPlane from 'js/core/primitives/HorizontalPlane';
import VerticalPlane from 'js/core/primitives/VerticalPlane';
import Capabilities from 'js/core/Capabilities'
import FloorSVGParser from 'js/components/FloorSVGParser';

export default class OHZIExampleApplication extends BaseApplication
{
  constructor(renderer)
  {
    super();
    this.renderer = renderer;

    this.camera_controller = new CameraController();
    this.normal_render_mode = new NormalRender();

    this.view_cube_layer = undefined;

  }



  start()
  {
    this.__init_camera();
    this.__init_camera_controller();
    this.__init_viewcube()
    // Debug.draw_axis();

    this.reference_position = new THREE.Vector3();

    let grid = new Grid();
    // SceneManager.current.add(grid);

    let light = new THREE.DirectionalLight(undefined, 1);
    let amb = new THREE.AmbientLight(0xffffff, 0);
    light.position.set(1,1,1).normalize();
    SceneManager.current.add(light);
    SceneManager.current.add(amb);



  //   let radiance_cube = ResourceContainer.get_resource("radiance");


  //   let pmremGenerator = new PMREMGenerator( radiance_cube );
		// pmremGenerator.update( Graphics._renderer );

		// let pmremCubeUVPacker = new PMREMCubeUVPacker( pmremGenerator.cubeLods );
		// pmremCubeUVPacker.update( Graphics._renderer );
		
		// let hdrCubeRenderTarget = pmremCubeUVPacker.CubeUVRenderTarget;
		// radiance_cube.magFilter = THREE.LinearFilter;
		// radiance_cube.needsUpdate = true;
		// pmremGenerator.dispose();
		// pmremCubeUVPacker.dispose();



    let glb_scene = ResourceContainer.get_resource("rose").scene;

    // glb_scene.scale.set(10,10,10);
    glb_scene.traverse((child)=>{
    	if(child.material)
    	{
    		if(child.material.map)
    		{
    			let tex = child.material.map;
	    		tex.anisotropy = Capabilities.max_anisotropy;
	    		child.material = new THREE.MeshBasicMaterial();
	    		child.material.map = tex;
	    		// child.material.envMap = radiance_cube;
    		}
    	}
    })

    SceneManager.current.add(glb_scene);

    // SceneManager.current.background = ResourceContainer.get_resource("skybox");

    // this.load_svg();
    // let svg_parser = new FloorSVGParser(ResourceContainer.get_resource("svg"));
    // let floor = svg_parser.parse("Floor_1_North");
    // SceneManager.current.add(floor);
    // console.log(floor)


    // this.camera_view_cube.bounding_box.setFromObject(floor);
    // console.log(this.camera_view_cube.bounding_box)
    // var helper = new THREE.Box3Helper( this.camera_view_cube.bounding_box, 0xffff00 );
    // SceneManager.current.add(helper);
  }

  load_svg()
  {
  	var paths = ResourceContainer.get_resource("svg").paths;
  	let xml = ResourceContainer.get_resource("svg").xml;
  	console.log(xml.getElementById("Units").parentNode)
    var drawFillShapes = true;
    var drawStrokes = false;
    var fillShapesWireframe = false;
    var strokesWireframe =false;
		var group = new THREE.Group();



		var extrudeSettings = {
			steps: 1,
			depth: 3,
			bevelEnabled: false,
			bevelThickness: 0.1,
			bevelSize: 0.5,
			bevelOffset: 0,
			bevelSegments: 20
		};
		
		
		for ( var i = 0; i < paths.length; i ++ ) {
			var path = paths[ i ];
			var fillColor = path.userData.style.fill;
			if ( drawFillShapes && fillColor !== undefined && fillColor !== 'none' ) {
				var material = new THREE.MeshStandardMaterial( {
					color: new THREE.Color().setStyle( fillColor ),
					opacity: path.userData.style.fillOpacity,
					transparent: path.userData.style.fillOpacity < 1,
					// side: THREE.DoubleSide,
					// depthWrite: false,
					wireframe: fillShapesWireframe
				} );
				var shapes = path.toShapes( true );
				for ( var j = 0; j < shapes.length; j ++ ) {
					var shape = shapes[ j ];
					var geometry = undefined;
					if(path.parentName === "Units")
						geometry = new THREE.ExtrudeBufferGeometry( shape, extrudeSettings );
					else
						geometry = new THREE.ShapeBufferGeometry( shape );

					var mesh = new THREE.Mesh( geometry, material );
					mesh.name = path.name;
					mesh.parentName = path.parentName;
					group.add( mesh );
				}
			}

		}
		console.log(group);
    SceneManager.current.add(group);


    group.traverse((child)=>{
    	if(child.geometry)
    	{
    		// console.log(child.name);
    		// child.geometry.translate(center.x, center.y, center.z);
    		child.geometry.rotateX(-Math.PI/2);
    	}
    });


    // group.rotation.x = -Math.PI/2;
  }

  resources_fully_loaded() {

  }

  update()
  {
    this.camera_controller.update();
    this.camera_view_cube.update();

  }





  __init_camera()
  {
    let camera = new PerspectiveCamera(60, Screen.aspect_ratio, 0.1, 400);
    // let camera = new OrthographicCamera( Screen.width / - 2, Screen.width / 2, Screen.height / 2, Screen.height / - 2, 0.1, 200 );
    // camera.zoom = 40;
    camera.updateProjectionMatrix();
    camera.position.z = 10;

    camera.clear_color.copy(new THREE.Color("#000000"));
    camera.clear_alpha = 1;
    CameraManager.current = camera;
  }

  __init_camera_controller()
  {
    this.camera_controller.set_camera(CameraManager.current);
    this.camera_controller.set_debug_mode();
    // this.camera_controller.set_idle();
    this.camera_controller.min_zoom = 15;
    this.camera_controller.max_zoom = 350;
    this.camera_controller.reference_zoom = 15;
    this.camera_controller.set_tilt(45);
    this.camera_controller.reference_position.set(0,13,0);
  }

  __init_viewcube()
  {
    this.view_cube_layer = {
    	camera: new OrthographicCamera(-1.1, 1.1, 1.1, -1.1, 0.1, 200),
    	scene: new THREE.Scene(),
    	viewport: new THREE.Vector4(Screen.width-256, Screen.height-256, 256, 256)
    }

    this.layered_render = new LayeredRender([this.view_cube_layer])
    Graphics.set_state(this.layered_render);


		let bounding_box = new THREE.Box3().setFromCenterAndSize(new THREE.Vector3(), new THREE.Vector3(1,10,5));

    this.camera_view_cube = new CameraViewCube( this.camera_controller, 
    																						0, 
  																							this.view_cube_layer.viewport, 
  																							this.view_cube_layer.camera,
  																							bounding_box);
    this.camera_view_cube.scale.set(0.5, 0.5, 0.5)
    // this.view_cube_layer.scene.add(this.camera_view_cube);
    
  }
}
